var React = require('react');

function Property (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.43.801l5.59 4.629a.5.5 0 0 1 .18.385V13.5a.5.5 0 0 1-.5.5H8.179a.5.5 0 0 1-.5-.5v-2.167a.5.5 0 0 0-.5-.5H5.022a.5.5 0 0 0-.5.5V13.5a.5.5 0 0 1-.5.5H.5a.5.5 0 0 1-.5-.5V5.816a.5.5 0 0 1 .182-.386L5.794.8a.5.5 0 0 1 .637.001zM0 .5v3.115L3.284.898V.5a.5.5 0 0 0-.5-.5H.5a.5.5 0 0 0-.5.5z","fill":"#424242","fillRule":"evenodd"}));
}

Property.defaultProps = {"width":"13","height":"14","viewBox":"0 0 13 14"};

module.exports = Property;

Property.default = Property;
